<template>
    <div>
        <div class="progress-top">
            <div>{{ $ton(unlockedAmount, 9, true) }} TON</div>
            <a v-on:click="detailsModalVisible = true">{{ $t('locker.details') }}</a>
        </div>
        <div class="progress">
            <!--<div class="progress-bar" v-bind:style="{ width: progress + '%' }"></div>-->
            <div
                class="progress-bar"
                v-for="i in 36"
                v-bind:class="{
                    'progress-bar--past': i <= progress,
                    'progress-bar--current': progress === i - 1,
                }"
                v-bind:key="`unlock_period_${i}`"
            />
        </div>
        <div class="progress-bottom muted">
            <div v-if="!nearest">{{ $t('locker.completed') }}</div>
            <div v-else-if="vestingStarted && unlockedAmount === '0'">{{ $t('locker.first_payment') }} <ui-timeago v-bind:timestamp="nearest * 1000" /></div>
            <div v-else-if="vestingStarted && unlockedAmount">{{ $t('locker.next_payment') }} <ui-timeago v-bind:timestamp="nearest * 1000" /></div>
            <div v-else>{{ $t('locker.starts') }} <ui-timeago v-bind:timestamp="nearest * 1000" /></div>
        </div>

        <!-- Modal with payment schedule -->
        <ui-modal v-bind:isOpen.sync="detailsModalVisible">
            <template slot="header">
                {{ $t('locker.payment_schedule') }}
            </template>

            <div class="tx-history-wrap desktop-table" style="max-height: 580px;">
                <table class="ui-table validators-table">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>{{ $t('locker.period_start') }}</th>
                            <th>{{ $t('locker.period_end') }}</th>
                            <th style="text-align: right">{{ $t('address.tx_table.value') }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(p, index) in tablePeriods" v-bind:key="index">
                            <td>{{ index + 1}}</td>
                            <td><ui-datetime v-bind:timestamp="p.start * 1000" hide-time /></td>
                            <td><ui-datetime v-bind:timestamp="p.end * 1000" hide-time /></td>
                            <td>{{ $ton('36593858201972578', 9, true) }} TON</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </ui-modal>
    </div>
</template>

<script>
import { formatDate } from '~/helpers';

const VESTING_START = 1760227200;
const UNLOCK_PERIOD = 2592000;
const VESTING_DURATION = 93312000;
const VESTING_END = VESTING_START + VESTING_DURATION;

const PAYOUTS = ['0', '36593858201972578', '73187716403945156', '109781574605917734', '146375432807890312',
    '182969291009862890', '219563149211835468', '256157007413808046', '292750865615780624', '329344723817753202',
    '365938582019725780', '402532440221698358', '439126298423670936', '475720156625643514', '512314014827616092',
    '548907873029588670', '585501731231561248', '622095589433533826', '658689447635506404', '695283305837478982',
    '731877164039451560', '768471022241424138', '805064880443396716', '841658738645369294', '878252596847341872',
    '914846455049314450', '951440313251287028', '988034171453259606', '1024628029655232184', '1061221887857204762',
    '1097815746059177340', '1134409604261149918', '1171003462463122496', '1207597320665095074', '1244191178867067652',
    '1280785037069040230',
];

export default {
    data() {
        return {
            periods: [],
            nearest: undefined,
            vestingStarted: false,
            progress: 0,
            unlockedAmount: 0,
            detailsModalVisible: false,
        };
    },

    mounted() {
        this.calculatePeriods();
        this.findNearestPayoutDate();
    },

    computed: {
        tablePeriods() {
            const result = [];
            for (let i = 0; i < this.periods.length - 1; i += 1) {
                result.push({
                    start: this.periods[i],
                    end: this.periods[i + 1],
                });
            }
            return result;
        },
    },

    methods: {
        formatDate,
        calculatePeriods() {
            for (let i = VESTING_START; i < VESTING_END + UNLOCK_PERIOD; i += UNLOCK_PERIOD) {
                this.periods.push(i);
            }
        },
        findNearestPayoutDate() {
            const now = Math.floor(Date.now() / 1000);
            const futurePayouts = this.periods.filter(ts => ts > now);
            // this.progress = Math.floor(((36 - futurePayouts.length) / 36) * 100) || 0;
            this.progress = 36 - futurePayouts.length || 0;
            this.unlockedAmount = PAYOUTS[36 - futurePayouts.length] || 0;

            if (futurePayouts.length === 0) {
                // Выплаты завершились
                this.unlockedAmount = '1317378895271012809';
                return;
            }
            this.nearest = Math.min(...futurePayouts); // Находим ближайшую дату выплат

            // Если вестинг уже начался
            if (now > this.periods[0]) {
                this.vestingStarted = true;
            }
        },
    },
};
</script>

<style scoped lang="scss">
.progress {
    display: flex;
    gap: 4px;
    width: 100%;
    height: 12px;
    //border-radius: 10px;
    overflow: hidden;
}

.progress-bar {
    height: 100%;
    width: 100%;
    background-color: var(--body-light-muted-color);
    border-radius: 3px;
    transition: 0.3s ease;

    &--current {
        background-color: var(--blue-bright);
        opacity: .5;
    }

    &--past {
        background-color: var(--blue-bright);
    }
}

.progress-top,
.progress-bottom {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.progress-top {
    margin-bottom: 4px;
}

.progress-bottom {
    margin-top: 4px;
}
</style>
